import request from "@/api/request";
import { Profile } from "@/interfaces/User/Profile";
import { TransactionList } from "@/interfaces/Transaction/TransactionList";

class UserService {
  static async switchLang(lang: string): Promise<void> {
    await request.post("/user/lang", { lang });
  }
  static async changePlaydateDescriptionBlock(hideDescriptionBlock: boolean): Promise<boolean> {
    return await request.post("/user/playdate_description_block_hidden", { hideDescriptionBlock });
  }
  static async changeUpcomingPlaydateBlock(hide: boolean): Promise<boolean> {
    return await request.post("/user/upcoming_playdate_block_hidden", { hide });
  }
  static async changeVideoAutoplay(autoplay: boolean): Promise<boolean> {
    return await request.post("/user/video_autoplay", { autoplay });
  }
  static async getProfile(): Promise<Profile> {
    return await request.get("/user/profile");
  }

  static async changePassword(password: string, newPassword: string): Promise<string> {
    return await request.post("/user/change_password", {
      password,
      newPassword,
    });
  }

  static async changeUserData(
    firstName: string | null,
    lastName: string | null,
    street: string | null,
    house: string | null,
    zip: number | null,
    city: string | null,
    country: number | null,
  ): Promise<void> {
    return await request.post("/user/change_personal_data", {
      firstName,
      lastName,
      street,
      house,
      zip,
      city,
      country,
    });
  }

  static async changeUserName(userName: string, chatName: string, password: string): Promise<void> {
    return await request.post("/user/change_username", {
      userName,
      chatName,
      password,
    });
  }

  static async changeEmail(newEmail: string, password: string | null = null): Promise<void> {
    return await request.post("/user/change_email", {
      newEmail,
      password,
    });
  }

  static async changeNotifications(hasPlaydateNotification: boolean, hasCameraMailNotification: boolean): Promise<void> {
    return await request.post("/user/change_notification_settings", {
      hasPlaydateNotification,
      hasCameraMailNotification,
    });
  }

  static async getPaymentHistory(page: number): Promise<TransactionList> {
    return await request.get("/user/get_payment_history", {
      page,
    });
  }
  static async subscribeNewsletter(): Promise<void> {
    await request.get("/user/subscribe_newsletter");
  }

  static async unsubscribeCameraMails(): Promise<void> {
    await request.get("/user/unsubscribe_mails");
  }

  static async verificationEmail(): Promise<void> {
    return await request.post("/user/verification_email");
  }

  static async verificationAge(): Promise<string> {
    return await request.get("/user/verification_age");
  }

  static async validateUsername(username: string): Promise<void> {
    return await request.post("/user/validate_username", { username });
  }

  static async validateEmail(email: string): Promise<void> {
    return await request.post("/user/validate_email", { email });
  }

  static async changeAvatar(avatar: number): Promise<void> {
    return await request.post("/user/change_avatar", { avatar });
  }

  static async twoFactorSetup(): Promise<{ secret: string; qr_uri: string }> {
    return await request.get("/user/2fa/setup");
  }

  static async twoFactorEnable(secret: string, code: string): Promise<void> {
    return await request.post("/user/2fa/enable", { secret, code });
  }

  static async twoFactorDisable(password: string): Promise<void> {
    return await request.post("/user/2fa/disable", { password });
  }
}

export default UserService;
